import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { getRideList } from "api/ride";
import BaseTable from "components/DataTable/BaseTable";
import ListingImageCol from "components/ListingImageCol";
import ListingStaffAvatarGroup from "components/ListingStaffAvatarGroup";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { formatDateTime, STATUS_ACTIVE } from "utils/helper";

const TABLE_COLUMNS = [
    { id: "name", Header: "Name", accessor: "name", align: "left", sortable: true },
    { id: "staff", Header: "Responsible staff", accessor: "numberOfStaff", align: "left" },
    { id: "created_at", Header: "Created At", accessor: "created_at", align: "left", sortable: true },
    { id: "status", Header: "Status", accessor: "status", align: "left" },
];

export const parentRoute = '/rides';
function RideTable() {
    const navigate = useNavigate();
    const location = useLocation();
    const [refreshKey] = useState(0);
    const savedState = location.state || { sort: "created_at", dir: "desc" };

    const createTableRow = useCallback((item) => ({
        name: <ListingImageCol imgUrl={item.img_url} name={item.name} />,
        numberOfStaff: <ListingStaffAvatarGroup staff={item.staff || []} />,
        created_at: (
            <MDTypography component="div" variant="standard" color="text">
                {formatDateTime(item.created_at)}
            </MDTypography>
        ),
        status: (
            <MDTypography component="div" variant="standard" color={item.status?.id === STATUS_ACTIVE ? "success" : "error"}>
                {item.status?.name}
            </MDTypography>
        )
    }), []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <BaseTable
                key={refreshKey}
                title="Rides Management"
                columns={TABLE_COLUMNS}
                fetchData={getRideList}
                defaultState={savedState}
                createTableRow={createTableRow}
                showAddButton
                addButtonText="Add Ride"
                onAddClick={() => navigate(`${parentRoute}/add-ride`, { state: savedState })}
                showSearch
                showStatusFilter
                searchPlaceholder="Search ride name..."
                onClickRow={(row, key) => { navigate(`${parentRoute}/${row.id}`, { state: savedState }) }}
            />
        </DashboardLayout>
    );
}

export default RideTable;